import { BaseQueryApi, FetchArgs, fetchBaseQuery } from '@reduxjs/toolkit/dist/query';
import config from '../../config/config';
import { toastError } from '../../utils/toasts';
import parseErrors from '../../utils/parseErrors';
import getErrorResponse from '../../utils/getErrorResponse';
import { logout } from '../slices/auth';
// import { logout } from '../slices/auth';

interface State {
  auth: { token: string; userData: unknown }
}

const baseQuery = fetchBaseQuery({
  baseUrl: `${config.baseURL}/v1/`,
  prepareHeaders: (headers, { getState }) => {
    const { token } = (getState() as State).auth;
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }
    return headers;
  },
});

const baseQueryWithReauth = async (args: string | FetchArgs, api: BaseQueryApi) => {
  const result = await baseQuery(args, api, {});
  if (result.meta?.response?.status === 401) {
    api.dispatch(logout());
  } else if (result.error) {
    const errorData = getErrorResponse(result.error);
    const errorMessage = parseErrors(errorData);
    if (errorMessage) {
      toastError(errorMessage);
    }
  }
  return result;
};

export default baseQueryWithReauth;
